module.exports = __webpack_public_path__ + "img/aboutUs3_en.1e8797d.png";